export default {
    props: {
        openOnClickRootMenuItems: {
            type: Boolean,
            default: undefined,
            kComposite: 'openOnClick.rootMenuItems'
        }, 
        openOnClickSubMenuItems: {
            type: Boolean,
            default: undefined,
            kComposite: 'openOnClick.subMenuItems'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoMenu/OpenOnClick.js